var render, staticRenderFns
import script from "./DealerAcount.vue?vue&type=script&lang=js"
export * from "./DealerAcount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0206cc6d')) {
      api.createRecord('0206cc6d', component.options)
    } else {
      api.reload('0206cc6d', component.options)
    }
    
  }
}
component.options.__file = "found/views/cps/views/rights/fee/dealer_acount/DealerAcount.vue"
export default component.exports